import { ChangeDetectionStrategy, Component, Input, ViewEncapsulation } from '@angular/core';

import { AnimationUtil } from '@mtna/lib-ui';
import { Variable } from '@mtna/pojo-consumer-ui';

/**
 * Variable Information Component to display variable properties.
 *
 * @author Zach Edwards <zach.edwards@mtna.us>
 */

@Component({
  selector: 'rds-variable-information',
  templateUrl: './variable-information.html',
  styles: [
    `
      rds-variable-information .mat-list-base .mat-list-item.mat-2-line.wrap-item {
        height: auto;
        padding: 16px 0;
      }
      rds-variable-information .mat-list-base .mat-list-item.mat-2-line.wrap-item p.mat-line {
        white-space: normal;
      }
      rds-variable-information .rds-variable-information-has-decorators {
        position: relative;
        /* 22px is the height of the icons */
        margin-bottom: calc(1em + 22px);
      }
      rds-variable-information h2 {
        margin-bottom: 1em;
      }
      rds-variable-information rds-variable-information-decorators {
        position: absolute;
        top: 100%;
        left: 0;
      }
    `
  ],
  animations: [AnimationUtil.EXPAND_IN_OUT],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class RdsVariableInformationComponent {
  /** Required variable to display */
  @Input()
  set variable(variable: Variable) {
    this._variable = variable;

    // Determine if there are any extra properties to show
    this.hasMoreProperties =
      !!this.variable &&
      (this._hasValue(this.variable.fixedStorageWidth) ||
        this._hasValue(this.variable.startPosition) ||
        this._hasValue(this.variable.endPosition) ||
        this._hasValue(this.variable.decimals));

    // Determine if there are any decorator properties to show
    this.hasDecorators = !!this.variable && (this.variable.isMeasure || this.variable.isRequired || this.variable.isWeight);
  }
  get variable(): Variable {
    return this._variable;
  }
  private _variable: Variable;
  /** Whether to show or hide the variable name */
  @Input() showVariableName: boolean;

  /** Wehther there are descorator properties to show */
  hasDecorators: boolean;
  /** Wehther there are extra properties to show */
  hasMoreProperties: boolean;
  /** Whether to show more properties */
  showMore: boolean;

  toggleShowMore() {
    this.showMore = !this.showMore;
  }

  private _hasValue(value: any) {
    return value !== undefined && value !== null;
  }
}
